module.exports = {
    COGNITO: {
        region: 'us-east-1',
        ClientId: 'cfb8o9c0mgsikuqu2s4ma24be',
        IdentityPoolId: 'us-east-1:1dae713b-bfe2-49f5-8db6-ec5add907c7d',
        UserPoolId: 'us-east-1_31YsM4yXE',
    },
    
  }






// WEBPACK FOOTER //
// ./src/env.js